import type { IconData } from '@stacksjs/iconify-core'

export const flash1Flat: IconData = {
  "body": "<path fill=\"#8fbffa\" d=\"M31.75 1.742c-3.662-.21-9.91-.428-16.07.022a5.28 5.28 0 0 0-4.546 3.389c-3.106 8.164-4.586 15.694-5.217 19.684c-.395 2.503 1.424 4.735 3.926 4.906c2.138.147 5.279.3 8.945.28c-.39 3.173-.797 7.407-1.202 11.961c-.361 4.08 4.545 6.533 7.465 3.404c7.497-8.033 14.37-16.966 18.138-22.057c2.074-2.8.248-6.718-3.293-6.81a173 173 0 0 0-5.99-.047c.697-3.038 1.327-6.339 1.906-9.525c.47-2.587-1.383-5.053-4.062-5.207\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default flash1Flat
